import { S3_IMAGES_URL } from '../../../constants';

export const CAROUSEL_IMAGES = [
  {
    id: 1,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_01.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_01.webp`,
    },
  },
  {
    id: 2,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_02.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_02.webp`,
    },
  },
  {
    id: 3,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_03.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_03.webp`,
    },
  },
  {
    id: 4,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_04.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_04.webp`,
    },
  },
  {
    id: 5,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_05.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_05.webp`,
    },
  },
  {
    id: 6,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_06.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_06.webp`,
    },
  },
  {
    id: 7,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_07.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_07.webp`,
    },
  },
  {
    id: 8,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_08.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_08.webp`,
    },
  },
  {
    id: 9,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_09.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_09.webp`,
    },
  },
  {
    id: 10,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_10.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_10.webp`,
    },
  },
  {
    id: 11,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_11.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_11.webp`,
    },
  },
  {
    id: 12,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_12.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_12.webp`,
    },
  },
  {
    id: 13,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_13.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_13.webp`,
    },
  },
  {
    id: 14,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_14.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_14.webp`,
    },
  },
  {
    id: 15,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_15.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_15.webp`,
    },
  },
  {
    id: 16,
    src: {
      desktop: `${S3_IMAGES_URL}carousel_block/desktop/img_16.webp`,
      mobile: `${S3_IMAGES_URL}carousel_block/mobile/img_16.webp`,
    },
  },
];
